import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'

export function useAuth() {
  const store = useAuthStore()
  const { uid, email, displayName, role, isAuthenticated, isReady } = storeToRefs(store)

  return {
    uid,
    email,
    displayName,
    role,
    isAuthenticated,
    isReady,
    login: store.login,
    register: store.register,
    logout: store.logout,
    resetPassword: store.resetPassword,
    uploadWaiverSignature: store.uploadWaiverSignature,
    deactivateAccount: store.deactivateAccount,
  }
}
